export default __webpack_public_path__ + "0a48733ba80e4094e996f9313dafe7bc.png";